import { render, staticRenderFns } from "./ManResult.vue?vue&type=template&id=66afee94&scoped=true"
import script from "./ManResult.vue?vue&type=script&lang=js"
export * from "./ManResult.vue?vue&type=script&lang=js"
import style0 from "./ManResult.vue?vue&type=style&index=0&id=66afee94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66afee94",
  null
  
)

export default component.exports